/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Escrow lifecycle states */
export enum EscrowStatus {
  Active,
  Completed,
  Disputed,
  Cancelled,
}

export type EscrowStatusArgs = EscrowStatus;

export function getEscrowStatusEncoder(): FixedSizeEncoder<EscrowStatusArgs> {
  return getEnumEncoder(EscrowStatus);
}

export function getEscrowStatusDecoder(): FixedSizeDecoder<EscrowStatus> {
  return getEnumDecoder(EscrowStatus);
}

export function getEscrowStatusCodec(): FixedSizeCodec<
  EscrowStatusArgs,
  EscrowStatus
> {
  return combineCodec(getEscrowStatusEncoder(), getEscrowStatusDecoder());
}
